import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Actions } from '../../interface/actions';

@Component({
  selector: 'custom-table',
  templateUrl: './custom-table.component.html',
  styleUrl: './custom-table.component.scss',
})
export class CustomTableComponent {
  @Input() actions: Actions[] = [];
  @Input() dataSource: any[] = [];
  @Input() columns: string[] = [];
  parentTranslator :string; 
  @Input() set translationPrefix(translationPrefix : string) { this.parentTranslator = translationPrefix }
  get translationPrefix():any { return  this.parentTranslator }

  @Output() selectedAction = new EventEmitter<any>();

  
  manageSelectedRow(row: any, status: string) {
    let data = { row, action: status }
    this.selectedAction.emit(data);
  }
}
